import { toast } from 'react-toastify';
import CustomToast from "../../app/containers/common/CustomToast";


export function showToast({ type, message, position = "bottom-left", className }) {
    const options = {
        position,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        closeButton: false,
        icon: false,
        className
    };

    if (type === 'error') {
        toast.error(<CustomToast message={message} />, options);
    } else if (type === 'success') {
        toast.success(<CustomToast type="info" message={message} />, {
            ...options,
            position: "top-right",
            className: 'toast-white-warning'
        });
    } else {
        toast(<CustomToast message={message} />, options);
    }
}